import qs from 'qs'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'
import { PrefixedRole } from '../../../ng/bridge-utils/roles'
import { getRbacStatus } from 'contrastBase/accessControl'
import { vanillaUserAndOrganizationStore } from 'contrastBase/state'

export interface OrganizationProfile {
  free_trial?: boolean
  properties?: {
    default_filtering_by_most_recent_session?: string
  }
}

interface Args {
  organizationUuid: string
  queryParams?: Record<string, string>
}

interface Response {
  organization: OrganizationProfile
  roles: PrefixedRole[]
  legacyRoles?: PrefixedRole[]
}

export async function getOrganizationProfile(
  this: ThisConnector,
  { organizationUuid, queryParams }
) {
  const queryResults = await this.connector.get(
    `/profile/organizations/${organizationUuid}${qs.stringify(queryParams, {
      addQueryPrefix: true
    })}`
  )
  const { currentUser } = vanillaUserAndOrganizationStore.getState()
  const { enabled, isAssessEnforced } = getRbacStatus()

  const isRbacEnforcedAvailable = enabled && isAssessEnforced
  return isRbacEnforcedAvailable && currentUser
    ? {
        ...queryResults,
        roles: currentUser.roles,
        legacyRoles: queryResults.roles
      }
    : queryResults
}

export const useOrganizationProfile = ({
  organizationUuid,
  queryParams = {}
}: Args) => {
  const { isLoading, error, data } = useContrastQuery<Args, Response>(
    [Query.ORGANIZATION_PROFILE, organizationUuid],
    getOrganizationProfile,
    { organizationUuid, queryParams },
    { enabled: !!organizationUuid }
  )

  return {
    isLoading,
    error,
    data
  }
}
